<template>
  <div :class="mobile ? 'pdf-view-mobile' : 'pdf-view'">
    <v-container fluid>
      <v-hover v-slot="{ hover }">
        <v-card tile elevation="5">
          <v-overlay :value="hover" absolute>
            <v-row style="padding: 6px">
              <v-btn
                color="primary"
                width="200px"
                href="data/cv_ruben_broekx.pdf"
                target="_blank"
              >
                Open in browser
                <v-icon right>mdi-open-in-app</v-icon>
              </v-btn>
            </v-row>
          </v-overlay>
          <v-img
            src="images/cv/cv_ruben_broekx.jpg"
            lazy-src="images/cv/low_res/cv_ruben_broekx.jpg"
          />
        </v-card>
      </v-hover>
    </v-container>
  </div>
</template>
 
<script>
export default {
  name: "CurriculumVitae",
  data() {
    return {
      mobile: window.innerWidth < 800,
      hover: false,
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.mobile = window.innerWidth < 800;
    });
  },
};
</script>

<style scoped>
.pdf-view {
  padding: 6px 64px;
}
.pdf-view-mobile {
  padding: 6px 6px;
}
</style>